import { CountryCode } from '@carsys/enums/country-code'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'

/**
 * Looks up the country used for the vehicle tree provider based on the redux state.
 */
const useDefaultVehicleProviderCountry = () =>
  useSelector<IRootReducerState, CountryCode>(
    state =>
      state.settings.defaultOrderAccount.details?.Wholesaler.Country || state.auth.shop.VisitorCountry || state.auth.shop.PostalCountry
  )
export default useDefaultVehicleProviderCountry
